import { BagPersonalPlusOutlineIcon } from './BagPersonalPlusOutlineIcon';

/**
 * author: Matthew Terry
 * id A34CE341-A59D-45C8-9F26-F4A9837915FF
 * name bag-personal-plus-outline
 * version: 7.3.67
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bag-personal-plus-outline.svg
 * tags
 */
export const BackpackPlusOutlineIcon = BagPersonalPlusOutlineIcon;
export default BackpackPlusOutlineIcon